// api.js — thin client for the backend. Same-origin in production; in dev the Vite
// proxy forwards /api to the Express server, so the session cookie works on localhost too.

export class AuthError extends Error {
  constructor() { super('unauthorized'); this.name = 'AuthError'; }
}

const JSON_HEADERS = { 'Content-Type': 'application/json' };

async function req(path, opts = {}) {
  let res;
  try {
    res = await fetch('/api' + path, { credentials: 'include', ...opts });
  } catch {
    throw new Error('Kunde inte nå servern. Kontrollera din anslutning.');
  }
  if (res.status === 401) throw new AuthError();
  let data = {};
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) throw new Error(data.error || 'Något gick fel.');
  return data;
}

const putJSON = (path, body) => req(path, { method: 'PUT', headers: JSON_HEADERS, body: JSON.stringify(body) });
const postJSON = (path, body) => req(path, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });

export const api = {
  // auth
  me: () => req('/auth/me'),
  config: () => req('/auth/config'),
  signup: (body) => postJSON('/auth/signup', body),
  login: (body) => postJSON('/auth/login', body),
  logout: () => req('/auth/logout', { method: 'POST' }),
  googleLoginUrl: '/api/auth/google',

  // per-user workspace
  getState: () => req('/state'),
  saveJobs: (jobs) => putJSON('/state/jobs', { jobs }),
  saveTemplates: (templates) => putJSON('/state/templates', { templates }),
  saveDefaultTemplate: (defaultTemplateId) => putJSON('/state/default-template', { defaultTemplateId }),
  saveSettings: (settings) => putJSON('/state/settings', { settings }),
};
